import React from 'react';
import { MapPin, Phone, MessageCircle, Send } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-24 pb-12 px-6 rounded-t-[3rem]" data-id="element-36">
      <div className="max-w-7xl mx-auto" data-id="element-37">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-20" data-id="element-38">
          <div data-id="element-39">
            <h2 className="text-4xl md:text-5xl font-semibold mb-6 tracking-tight" data-id="element-40">
              Потрібна оцінка
              <br data-id="element-41" />
              майна?
            </h2>
            <p className="text-gray-400 text-lg max-w-md font-light mb-8" data-id="element-42">
              Зв'яжіться з нами для швидкого оформлення. Ідентифікатор протягом
              години!
            </p>

            <div className="flex flex-wrap gap-4" data-id="element-43">
              <a href="https://t.me/otsinkaua" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-[#2AABEE] hover:bg-[#2298D6] transition-colors px-6 py-3 rounded-full text-sm font-medium" data-id="element-44">
                <Send size={18} data-id="element-45" />
                Наш Telegram-канал
              </a>
              <a href="viber://chat?number=%2B380971264678" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-[#7360F2] hover:bg-[#5E4CDA] transition-colors px-6 py-3 rounded-full text-sm font-medium" data-id="element-46">
                <MessageCircle size={18} data-id="element-47" />
                Viber
              </a>
            </div>
          </div>

          <div className="flex flex-col justify-center space-y-8 md:pl-12 md:border-l border-white/10" data-id="element-48">
            <div data-id="element-49">
              <p className="text-gray-500 text-sm mb-2 uppercase tracking-wider" data-id="element-50">
                Телефон
              </p>
              <a href="tel:+380971264678" className="text-2xl md:text-3xl font-medium hover:text-gray-300 transition-colors flex items-center gap-3" data-id="element-51">
                <Phone size={24} className="text-gray-500" data-id="element-52" />
                +38 097 126 46 78
              </a>
            </div>

            <div data-id="element-53">
              <p className="text-gray-500 text-sm mb-2 uppercase tracking-wider" data-id="element-54">
                Локація
              </p>
              <div className="text-xl md:text-2xl font-medium flex items-start gap-3" data-id="element-55">
                <MapPin size={24} className="text-gray-500 shrink-0 mt-1" data-id="element-56" />
                <span data-id="element-57">
                  Білгород-Дністровський,
                  <br data-id="element-58" />
                  <span className="text-gray-400 text-lg" data-id="element-59">Одеська область</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500" data-id="element-60">
          <p data-id="element-61">© {new Date().getFullYear()} Оцінка майна. Всі права захищені.</p>
          <p data-id="element-62">
            Всі роботи виконуються з повним дотриманням чинного законодавства.
          </p>
        </div>
      </div>
    </footer>;
}